import React, { useState } from 'react';
import ReactTable from 'react-table'
import moment from 'moment'
import ReactLoading from 'react-loading';
import {Modal, Button, Dropdown} from 'react-bootstrap';
import CourierDetailsForm from '../forms/CourierDetailsForm';
import DeliveryNoteForm from '../forms/DeliveryNoteForm';
import {
    deleteAdminOrder,
    updateAdminDeliveryNote,
    updateAdminOrderConfirm,
    updateAdminOrderCourier,
    updateAdminOrderStatus,
    updateAdminPrice,
    updateAdminOrderPending,
    notifyReceiverWaybill,
    notifyCourier,
    verifyCOD,    
    disburseCOD,
    confirmAdminBatchOrder,
    confirmAdminBatchPlacedOrders,
    deleteAdminBatchOrders
} from '../../store/action/order';
import { timerCountdown } from '../../services/helpers/time';
import { isAuthenticated } from '../../store/action/auth';
import { nextStatus } from '../../services/helpers/status';
import WaybillOrder  from '../templates/pdfs/waybillLabel';
import WaybillBulkOrder from '../templates/pdfs/waybillBulkLabel';
import numeral from 'numeral';
import {
    courierWithInstantPickup,
    courierWithMultipleItems,
    normalizeCourierServices
} from "../../services/helpers/courier";
import {PDFDownloadLink} from "@react-pdf/renderer";
import {CopyToClipboard} from "react-copy-to-clipboard";
import EditOrderForm from "../forms/EditOrderForm";
import { FiCodesandbox } from 'react-icons/fi';

const AdminOrderTable = props => {
  const { user, token } = isAuthenticated();
  const selectedData = props.data.filter(i => i.selected);
  const totalSelected = selectedData.length;
  const [show, setShow] = useState(false);
  const [data, setData] = useState({});
  const [ selectedOrderId, setSelectedOrderId ] = useState('');
  const [ editOrderModal, setEditOrderModal ] = useState(false);
  const [orderId, setOrderId] = useState('');
  const [modalType, setModalType] = useState('info');
  const [loadings, setLoadings] = useState({
      origin:false,
      destination:false,
      couriers:false
  });

  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    courierTrackingId:"",
    courierWaybillId:"",
    courierName:"",
    courierPhone:"",
    courierType:"",
    courierCompany:"",
    courierLink:"",
    deliveryNote:"",
    items:[],
    price:0
  });

  const columns = [{
      getProps: (state, rowInfo) => {
          if (rowInfo && rowInfo.original) {
              return {
                  style: {
                      background:
                          rowInfo.original.orderType === "pickupAppBulk" ? "#ff9c96" : null
                  }
              };
          } else {
              return {};
          }
      },
      Header: ({row,original})  => checkBoxes('header',original),
      Cell: ({row,original})  => checkBoxes('row',original),
      minWidth: 30,
      className:'text-center',
      headerClassName: 'text-center'
    },{
      Header: 'PENGIRIM',
      accessor: 'shipperOrganization',
      Filter: ({filter, onChange}) => (
        <input type='text' style={{width:'90%'}} placeholder="Nama Organisasi" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)}/>
      ),
      Cell: ({row, original}) => shipperDetails(original)
    },{
      Header: 'DETAIL PENGIRIMAN',
      accessor: 'orderId',
      minWidth: 180,
      Filter: ({filter, onChange}) => (
        <input type='text' placeholder="Order ID" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)}/>
      ),
      Cell: ({row, original}) => originDetails(original)
    },{
      Header: 'BARANG',
      accessor: 'receiverName',
      style: { 'whiteSpace': 'unset'},
      Filter: ({filter, onChange}) => (
        <input type='text' style={{width:'90%'}} placeholder="Nama Penerima" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)}/>
      ),
      Cell: ({row, original}) => itemDescription(original)
    },{
      Header: 'TANGGAL KIRIM',
      accessor: 'orderType',
      style: { 'whiteSpace': 'unset'},
      Filter: ({filter, onChange}) => (
        <input type='text' style={{width:'90%'}} placeholder="Tipe Order" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)}/>
      ),
      Cell: ({row, original}) => timeCell(original)
    },{
      Header: 'KURIR',
      accessor: 'courierCompany',
      style: { 'whiteSpace': 'unset'},
      Filter: ({filter, onChange}) => (
        <input type='text' style={{width:'90%'}} placeholder="Nama Kurir" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)}/>
      ),
      Cell: ({row, original}) => courierCell(original)
    },{
      Header: 'STATUS',
      accessor: 'courierType',
      className:'status-container',
      Filter: ({filter, onChange}) => (
        <input type='text' style={{width:'90%'}} placeholder="Layanan Kurir" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)}/>
      ),
      style: { 'whiteSpace': 'unset', 'color':'#459BD8'},
      Cell: ({row, original}) => spanStatus(original)
    },{
      Header: 'NOMINAL(Rp)',
      accessor: 'courierStatus',
      Filter: ({filter, onChange}) => (
        <input type='text' style={{width:'90%'}} placeholder="Status Kurir" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)}/>
      ),
      style: { 'whiteSpace': 'unset'},
      Cell: ({row, original}) => priceCell(original)
    },{
      Header: 'KETERANGAN',
      accessor: 'courierWaybillId',
      style: { 'whiteSpace': 'unset'},
      Filter: ({filter, onChange}) => (
        <input type='text' style={{width:'90%'}} placeholder="Resi Kurir" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)}/>
      ),
      Cell: ({row, original}) => infoCell(original)
    },{
      Header: 'AKSI',
      accessor: 'paymentMethod',
      Filter: ({filter, onChange}) => (
        <input type='text' style={{width:'90%'}} placeholder="Tipe Pembayaran" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)}/>
      ),
      Cell: ({row,original}) => updateStatusButton(original)
    }
  ];

  const filterCell = ({filter,onChange}) => {
    
  }

  const checkBoxes = (type,value) => {
    const availableForConfirm = props.data.filter(i =>
        i.status === 'placed' &&
        i.selected && (
            courierWithInstantPickup(i.courierCompany) ||
            i.orderType === 'form'
        )
    );

    const totalData = props.data.length;
    const totalAvailableConfirm = availableForConfirm.length;
    if (props.tab === 9 || props.tab === 8 ) {
        return null
    } else if (type === 'header') {
        return (
            <Dropdown className="btn-group btn-group-sm">
                <Dropdown.Toggle
                    id="dropdown-basic"
                    className={`${totalSelected > 0 ? 'btn-primary text-white shadow' : 'btn-secondary'} 
                    order-table-action-button py-1 px-2 btn-sm dropdown-toggle`
                    }
                    style={{'fontSize':'12px', 'marginTop':'-5px', 'zIndex':99}}
                >
                    {totalSelected > 0 ? `(${totalSelected}) TERPILIH` : 'PILIH'}
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu-scroll">
                    <Dropdown.Header>{totalSelected > 0 ? totalSelected : 'Belum ada'} pesanan terpilih</Dropdown.Header>
                    <Dropdown.Divider/>
                    {
                        totalSelected === totalData ?
                            <Dropdown.Item onClick={() => props.onClickCheckBox(type,value)} className="text-info text-">
                                Hilangkan Pilihan
                            </Dropdown.Item>
                            :
                            <Dropdown.Item onClick={() => props.onClickCheckBox(type,value)} className="text-info text-">
                                Pilih Semua
                            </Dropdown.Item>
                    }

                    <Dropdown.Item
                        onClick={() => onPrintSelected(selectedData)}
                        disabled={!totalSelected > 0}
                        className={`${totalSelected > 0 ? null : 'text-muted'} text-info text-`}
                    >
                        Print {totalSelected > 0 ? totalSelected : null} Pesanan
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={props.tab === 1 ? () => onConfirmBatchPlacedOrders() : () => onConfirmBatchOrder()}
                        disabled={!totalSelected > 0}
                        className={`${totalSelected > 0 ? null : 'text-muted'} text-info text-`}
                    >
                        Next {totalSelected > 0 ? totalSelected : null} Pesanan
                    </Dropdown.Item>
                    <hr className='my-3'/>
                    <Dropdown.Item
                        onClick={() => onDeleteBatchOrders()}
                        disabled={!totalSelected > 0}
                        className={`${totalSelected > 0 ? null : 'text-muted'} text-danger mb-2 text-`}
                    >
                        Hapus {totalSelected > 0 ? totalSelected : null} Pesanan
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        )
    } else {
        return (
            <label htmlFor={`${value.orderId}`} className="si si-checkbox mt-2">
                <input
                    onClick={() => props.onClickCheckBox(type,value)}
                    type="checkbox"
                    checked={value.selected}
                    id={`${value.orderId}`}
                />
                <span className="si-label"></span>
            </label>
        )
    }
  };

  const shipperDetails = (og) => {
      let textColor;
      switch (og.orderType) {
          case 'dashboard':
          case 'dashboardManyDestinations':
              textColor = 'green';
              break;
          case 'adminDashboardBulk':
              textColor = 'orange';
              break;
          case 'api':
              textColor = 'blue';
              break;
          case 'form':
              textColor = 'red';
              break;
          case 'pickupAppBulk':
          case 'pickupAppSingle':
              textColor = 'red';
              break;
          default:
              textColor = 'blue'
      }

    return (
        <div>
            <b>
                <p style={{color:textColor}}
                   className="mb-0">
                    <i>{og.orderType}</i>
                </p>
            </b>
            <b>{og.shipperOrganization}</b><br/>
            {og.shipperPhone}<br/>
            {og.shipperName}<br/>
            {og.shipperEmail}<br/>
            <i>({og.paymentType})</i>
            <br/>
            <button
                className="badge badge-info border border border-info pointer"
                onClick={() => window.open(`/admin/users/${og.userId}`)}
            >
                User Page
            </button>
        </div>
    )
  };

    const originDetails = (o) => {
        let receiverView;
        if (o.orderType === "pickupAppBulk") {
            receiverView = (
                <div className="row">
                    <div className="col-1 px-0">
                            <span className="text-danger">
                                <i className="fas fa-map-marker-alt mt-1"/>
                            </span>
                    </div>
                    <div className="col-11 pl-0">
                        <strong>Pengiriman Banyak</strong><br/>
                        Perlu input data pengiriman di halaman user <br/>
                        Terdapat {o.receiverNote} Total Destinasi
                    </div>
                </div>
            )
        } else {
            receiverView = (
                <div className="row">
                    <div className="col-1 px-0">
                            <span className="text-danger">
                                <i className="fas fa-map-marker-alt mt-1"/>
                            </span>
                    </div>
                    <div className="col-11 pl-0">
                        <strong>{o.receiverName} </strong>
                            {o.receiverCODAmount > 0 ?
                                <span className="badge badge-danger">
                                    COD Rp {numeral(o.receiverCODAmount).format("0,0")}
                                </span>: null
                            }
                            {o.courierInsuranceAmount > 0 ?
                                <span className="badge badge-warning">
                                    Asuransi Rp {numeral(o.courierInsuranceAmount).format("0,0")}
                                </span>: null
                            }
                        <br/>
                        {o.receiverPhone}<br/>
                        {o.receiverLocation} <br/>
                        Kodepos: {o.receiverPostalCode} <br/>
                        <i>{o.receiverNote === '-' ? null : o.receiverNote}</i>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <small>ORDER ID: {o.orderId.toUpperCase()}</small>
                <div className="pl-3">
                    <div className="row">
                        <div className="col-1 px-0">
                            <span className="text-primary">
                                <i className="fas fa-map-marker-alt mt-1"/>
                            </span>
                        </div>
                        <div className="col-11 pl-0">
                            <strong>{o.originName}</strong> <br/>
                            {o.originPhone} <br/>
                            {o.originLocation} <br/>
                            Kodepos: {o.originPostalCode} <br/>
                            <i>{o.originNote === '-' ? null : o.originNote}</i>
                        </div>
                    </div>
                    <div className="py-1"/>
                    {receiverView}
                </div>
            </div>
        )
    };

  const timeCell = (og) => {
    let laterTime = (
        moment(og.deliveryDate).format("YYYY-MM-DD") + ' ' +
        moment(og.deliveryTime,"HH:mm:ss").format("HH:mm")
    );
    
    let timeInfo;
    let historyView;
    if (og.courierHistory && og.courierHistory.length > 0) {
      const reverseHistory = og.courierHistory.reverse().slice(0, 2);
      const reverseReverseHistory = reverseHistory.reverse();
      historyView = (
        <div className=''>
          {
            reverseReverseHistory.map(i => (
              <div className="mt-2 border p-2">
                <text><b>{i.status} - </b>{i.note} </text>
                <text></text><br/>
                <text>{moment(i.eventDate).format("YYYY-MM-DD HH:mm")}</text>
              </div>
            ))
          }
        </div>
      )
    }
    if (og.status === 'delivered') {
      const arrivalDate = og.courierHistory ? og.courierHistory[og.courierHistory.length-1].eventDate : null;
      timeInfo = (
        <div className="mt-2">
          <small>Waktu Diterima </small><br/>
          {moment(arrivalDate).format("YYYY-MM-DD HH:mm:ss")}<br/>
          <span className="badge badge-danger mr-2">
            {moment().diff(moment(arrivalDate), 'days')} hari lewat
          </span>
          <span className="badge badge-info">
            {og.receiverCODType || '7 days'}
          </span>
        </div>
        
      )
    }
    if (og.deliveryType === 'later') {
      if (og.status === 'placed') {
        return (
            <div>
              {laterTime} <br/>
              <small className="text-danger"><i>{timerCountdown(laterTime)}</i></small>
              {historyView}
            </div>
        )
      } else {
        return (
            <div>
              {laterTime}
              {timeInfo}
              {historyView}
            </div>
        )
      }
    } else {
      return (
        <div>
          {moment(`${og.deliveryDate} ${og.deliveryTime}`).format("YYYY-MM-DD HH:mm")}
          {timeInfo}
          {historyView}
        </div>
      )
    }
  };

    const itemDescription = (og) => {
        let { courierCompany,orderType,items } = og;

        if (og.orderType !== "pickupAppBulk"){
            return (
                <div>
                    <small>LIST BARANG</small>
                    { items.map((i,idx) => (
                        <div key={idx} className="rounded p-2 mb-1 border shadow--hover">
                            <small><b>{i.quantity}x - {i.name}</b> {i.description}</small><br/>
                            <small>Rp. {numeral(i.value).format("0,0")} <br/></small>
                            <small>{i.length}x{i.width}x{i.height} cm - {i.weight} gram</small>
                        </div>
                    ))}
                </div>
            )
        } else if (og.orderType === "pickupAppBulk") {
            return (
                <div>
                    <small>TOTAL BARANG</small><br/>
                    {items[0].quantity} Barang
                </div>
            )
        }

        return (
            <div>
                {og.note}
            </div>
        )
    };

  const priceCell = (og) => {
      const { orderId, courierCompany,courierWaybillId, courierType, courierTrackingId } = og;

      if (og.orderType === "pickupAppBulk") {
          return (
              <div className="text-muted">
                  Harga akan muncul ketika telah dijemput kurir
              </div>
          )
      }

      if (og.orderType === "pickupAppBulkByAdmin") {
          return (
              <div>
                  Rp. {numeral(og.price).format("0,0")} <br/>
                  {og.paymentMethod.toUpperCase()}<br/>
                  <i>Tidak bisa ganti harga</i>
              </div>
          )
      }

      return (
        <div>
          Rp. {numeral(og.price).format("0,0")} <br/>
          <p>{og.paymentMethod.toUpperCase()}</p>
          <button
              onClick={() => handleModalShow(orderId,courierTrackingId, courierWaybillId, courierCompany,courierType,"priceChange")}
              className="badge badge-warning pointer"
          >
            Ganti Harga
          </button>
        </div>
    )
  };

  const onClickPrint = (data) => {
      setShow(true);
      setData(data);
      setModalType('print')
  };

  const onPrintSelected = (data) => {
      setShow(true);
      setData(data);
      setModalType('printSelected')
  };


  const infoCell = (og) => {
    let { extra } = og;
    let extraView,interval; 
    
    if (og.timeToPickup) {
      let badgeColor,textInfo;
      if (og.timeToPickup < 2) {
        badgeColor=`badge-success`
        textInfo = `Dibawah 2 hari. Pastikan dijemput`
      } else if (og.timeToPickup >= 2 && og.timeToPickup < 14) {
        badgeColor=`badge-warning`
        textInfo = `Hari ke 2 - 14. Area waktu penjemputan bahaya, customer pasti protes`
      } else {
        badgeColor=`badge-danger`
        textInfo = `Diatas 14 hari. Anggap penjemputan gagal dan silahkan dicancel`
      }
      interval = (
        <div>
          <text className={`badge ${badgeColor} border px-2`}><b>{og.timeToPickup} hari</b></text> semenjak dikonfirmasi <br/><br/>
          <text>{textInfo}</text>
        </div>
      )
    }
  
    if (extra && extra.length > 0) {
      extraView = (
        <div>
           <small>EXTRA REQUEST</small>
           <div className="rounded p-2 mb-1 border shadow--hover">
           { extra.map((i,idx) => (
                <div key={idx} className="mb-1">
                    <small>{i.name.toUpperCase()} {i.fee ? <b>{`+ Rp. ${numeral(i.fee).format("0,0")}`}</b> : null}</small>
                </div>
            ))}
           </div>
        </div>
      ) 
    }
    return (
      <div>
          { extraView }
          { interval }
      </div>
    )
  };

  const updateStatusButton = (original) => {
    const {
        orderId,
        status,
        courierName,
        courierCompany,
        courierType,
        courierTrackingId,
        courierWaybillId,
        orderType,
        originName,
        originPhone,
        originLocation,
        originPostalCode,
        receiverCODStatus,
        receiverCODAmount
    } = original;

    let truck = (
      <button onClick={() => handleModalShow(orderId,courierTrackingId,courierWaybillId,courierCompany,courierType,'deliveryNote')}
        className="badge badge-warning border border-warning pointer py-2  mr-2"
        >
        Note
      </button>
    );
    let trash = (
      <button onClick={status === 'placed' ?
          () => onUpdatePlacedOrder(orderId,'rejected') :
          () => onRejectOrder(orderId,'rejected',courierName,original)}
        className="badge badge-danger border border-danger pointer py-2"
        >
        Tolak
      </button>
    );
    let next = (
      <button onClick={status === 'pending' ?
          () => onUpdatePendingOrder(orderId,'paid') :
          status === 'placed' ?
          () => onUpdatePlacedOrder(orderId,'confirmed') :
          () => onStatusChange(orderId,status,courierWaybillId,original)}
        className="badge badge-primary border border-primary pointer py-2  mr-2"
        >
        Next
      </button>
    );
    let forceNext = (
      <button onClick={() => onStatusChange(orderId,status,courierWaybillId,original,true)}
        className="badge badge-primary border border-primary pointer py-2  mr-2"
        >
        Paksa Next
      </button>
    );
    let info = (
        <button
            className="badge badge-info border border border-info pointer py-2"
            onClick={() => window.open(`/admin/orders/${orderId}`)}
        >
          Detail
        </button>
    );
    let cancel = (
        <button onClick={status === 'pending' ?
            () => onUpdatePendingOrder(orderId,'cancelled') :
            () => onDeleteOrder(orderId)}
                className="badge badge-danger border border-danger pointer py-2"
        >
          Batal
        </button>
    );
    let print = (
      <button onClick={() => onClickPrint(original)}
              className="badge badge-primary border border-primary pointer py-2 mr-2"
      >
          Print
      </button>
    );
    let wa = (
        <button onClick={() => onNotifyWaybillReceiver(orderId)}
                className="badge badge-primary border border-primary pointer py-2  mr-2"
        >
            Notif Customer
        </button>
    );
    let notifyCourier;
    if (courierCompany === 'jne') {
      notifyCourier = (
        <div>
          <button onClick={() => onNotifyCourier(orderId,'bike')}
                  className="badge badge-primary border border-primary pointer py-2  mr-2"
          >
              Notif Kurir Motor
          </button> <br/>
          <button onClick={() => onNotifyCourier(orderId,'car')}
                  className="badge badge-primary border border-primary pointer py-2  mr-2"
          >
              Notif Kurir Mobil
          </button>
        </div>
      );
    } else {
      notifyCourier = (
        <button onClick={() => onNotifyCourier(orderId)}
                className="badge badge-primary border border-primary pointer py-2  mr-2"
        >
            Notif Kurir
        </button>
      );
    }
    
    let cod = null;
    if (receiverCODAmount) {
      if (receiverCODStatus === 'pending') {
        cod = (
          <button onClick={() => onVerifyCOD(orderId)}
                  className="badge badge-info border border-primary pointer py-2  mr-2"
          >
              Verifikasi COD
          </button>
        );
      } else if (receiverCODStatus === 'verifying') {
        cod = (
          <button onClick={() => onPaidCOD(orderId)}
                  className="badge badge-info border border-primary pointer py-2  mr-2"
          >
              Disburse COD
          </button>
        );
      }
    }
    let cb = (
        <CopyToClipboard
            text={`Hallo tim ${courierCompany}. Ada request penjemputan ya, berikut detil nya:\n\n*Lokasi Jemput*\nNama:${originName}\nHP:${originPhone}\nAlamat:${originLocation}\nKodepos:${originPostalCode}\n\nLayanan:*${courierType.toUpperCase()}*\n\nTerima kasih ya tim :)`}
            onCopy={() => alert('Sudah dicopy')}
        >
            <button
                    className="badge badge-primary border border-primary pointer py-2"
            >
                Copy
            </button>
        </CopyToClipboard>
    )

    let retur;
    if (status === 'droppingOff' || status === 'returnInTransit') {
      retur = (
        <button onClick={() => onUpdateOrder(orderId,status === 'droppingOff' ? 'returnInTransit':'returned',courierName,original)}
                className="badge badge-primary border border-primary pointer py-2  mr-2"
        >
            { status === 'droppingOff' ? 'Proses Retur' : 'Retur'}
        </button>
      );
    }
    
    let dispose;
    if (status === 'droppingOff') {
      dispose = (
        <button onClick={() => onUpdateOrder(orderId,'disposed',courierName,original)}
                className="badge badge-primary border border-primary pointer py-2  mr-2"
        >
            Hancurkan
        </button>
      );
    }

    let editOrder = (
      <button onClick={() => {
          setSelectedOrderId(orderId);
          setEditOrderModal(true)
        }}
        className="badge badge-primary border border-primary pointer py-2 mr-2"
      >
        Edit
      </button>
    )


    if (status === 'delivered' ) {
      return (
        <div>
          {cod}
        </div>
      )
    } else if ( status === 'cancelled') {
      return <div className="text-muted"><i>(Cancel)</i></div>
    } else if ( status === 'scheduled') {
      return null
    } else if ( status === 'rejected') {
      return <div className="text-muted">
        {truck} <br/>
          {cancel} <br/>
        <i>(Ditolak)</i>
      </div>
    } else if (status === 'pending') {
        return (
            <div className="container">
                <div className="row">
                    {next}
                    {cancel}
                </div>
            </div>
        )
    } else {
      return (
        <div className="container">
            <div className="row">
                {truck}
                {orderType === 'api' ? null : info }
            </div>
            <div className="row">
                {next}
                {trash}
            </div>
            <div className="row">
                {print}
                {cancel}
            </div>
            <div className="row">
                {editOrder}
                {cb}
            </div>
            <div className="row">
                {wa}
            </div>
            <div className="row">
                {forceNext}                
            </div>
            <div className="row">
                {retur}    
                {dispose}                
            </div>
        </div>
      )
    }
  };

  const handleModalClose = () => setShow(false);

  const handleModalShow = (orderId, courierTrackingId, courierWaybillId, company,type,modalType, items) => {
    setModalType(modalType);
    setOrderId(orderId);
    setValues({
      courierTrackingId,
      courierWaybillId,
      courierCompany:company,
      courierType:type,
      items: items
    });
    setShow(true);
  };

  const spanStatus = (original) => {
    const { status, orderId, deliveryNote } = original;
    let statusView;

    if (status === 'placed') {
      statusView = (
        <div>
          Belum Siap Kirim
        </div>
      );
    } else if (status === 'scheduled') {
      statusView = (
        <div>
          Terjadwal
        </div>
      );
    } else if (status === 'confirmed') {
      statusView = (
        <div className="status-container cell-status-ready text-success">
          <ReactLoading
            type={'bubbles'}
            color={'#28a745'}
            height={24}
            width={24}/>
          Siap Dikirim
        </div>
      );
    } else if (status === 'allocated') {
      statusView = (
        <div>
          Sedang dipesan <br/>
        </div>
      );
    } else if (status === 'pickingUp') {
      statusView = (
        <div>
          Menjemput barang <br/>
        </div>
      );
    } else if (status === 'picked') {
      statusView = (
        <div>
          Barang telah dijemput
        </div>
      );
    } else if (status === 'droppingOff') {
      statusView = (
        <div>
          Menuju lokasi penerima
        </div>
      );
    } else if (status === 'returnInTransit') {
      statusView = (
        <div>
          Otw retur ke pengirim
        </div>
      );
    } else if (status === 'delivered') {
      statusView = (
        <div>
          Berhasil
        </div>
      );
    } else if (status === 'rejected') {
      statusView = (
        <div className="text-muted">
          <i>(Ditolak)</i>
        </div>
      );
    } else if (status === 'courierNotFound') {
      statusView = (
          <div className="text-muted">
            <i>(Kurir Tidak Ditemukan)</i>
          </div>
      );
    } else if (status === 'cancelled') {
      statusView = (
        <div className="text-muted"><i>(Cancel)</i></div>
      );
    }

    return (
      <div>
        {statusView}
        <br/>
        <text className="text-muted">status website kurir</text>
        <span className={`badge ${original.courierStatus === 'delivered' ? "badge-success" :"badge-warning"}`}>cs-{original.courierStatus}</span>
        <i className="text-muted text-black">{deliveryNote}</i>
      </div>
    )
  };

  const onSubmitDeliveryNote = () => {
    updateAdminDeliveryNote(token, orderId, values.deliveryNote)
      .then(data => {
        if(data.success){
          setShow(false);
          alert(`Berhasil update status pengiriman`)
          props.onRefresh();
        } else {
          alert("Error. Gagal update status pengiriman")
        }
      })
  };

  const onSubmitCourierDetails = () => {
    updateAdminOrderCourier(token, orderId, values)
      .then(data => {
        if(data.error) {
          setValues({...values, error: data.error})
        } else {
          setValues({
            ...values,
            courierWaybillId:"",
            courierName:"",
            courierPhone:"",
            courierType:"",
            courierCompany:"",
            courierLink:""
          });
          alert('Kurir berhasil diupdate');
          setOrderId('');
          handleModalClose();
          props.onRefresh();
        }
      })
  };

  const onSubmitPriceChange = async () => {
    updateAdminPrice(token, orderId, values.price)
        .then(data => {
          if(data.error) {
              alert(data.error)
              setValues({...values, error: data.error})
          } else {
            setValues({
              ...values,
              price:0
            });
            alert('Harga berhasil diganti')
            setOrderId('');
            handleModalClose();
            props.onRefresh();
          }
        })
  };

  const onUpdatePlacedOrder = async (orderId,status) => {
    if(window.confirm(`Kamu yakin mau ${status} order pelanggan?`)) {
      updateAdminOrderConfirm(token, orderId, status)
        .then(res => {
          if(res.success){
            alert(`Sudah Diganti ke status ${res.order.status}`);
            props.onRefresh();
          } else {
            alert(res.error)
          }
        })
    }
  };

    const onUpdatePendingOrder = async (orderId,status) => {
        if(window.confirm(`Kamu yakin mau konfirmasi order pelanggan?`)) {
            updateAdminOrderPending(token, orderId,status)
                .then(res => {
                    if(res.success){
                        alert(`Pembayaran dikonfirmasi`);
                        props.onRefresh();
                    } else {
                        alert(res.error)
                    }
                })
        }
    };

  const onNotifyWaybillReceiver = async (orderId) => {
      await notifyReceiverWaybill(token, orderId)
          .then(res => {
              if (res.success){
                  alert("berhasil di notifikasi")
              } else {
                  alert("gagal di notifikasi")
              }
          })
  };

  const onNotifyCourier = async (orderId,carType) => {
      if(window.confirm(`Kamu yakin mau notifikasi kurir?`)) {
          await notifyCourier(token, orderId,carType)
              .then(res => {
                  if (res.success){
                      alert("kurir berhasil di notifikasi")
                  } else {
                      alert("kurir gagal di notifikasi")
                  }
              })
      }
  }

  const onVerifyCOD = async (orderId) => {
    if(window.confirm(`Kamu yakin mau verifkasi COD?`)) {
      await verifyCOD(token, orderId)
          .then(res => {
              if (res.success){
                  alert("COD berhasil di verify")
              } else {
                  alert("COD gagal di verify")
              }
          })
    }
  }
  const onPaidCOD = async (orderId) => {
    if(window.confirm(`Kamu yakin disburse COD?`)) {
      await disburseCOD(token, orderId)
          .then(res => {
              if (res.success){
                  alert("COD berhasil dibayar")
              } else {
                  alert("COD gagal dibayar")
              }
          })
    }
  }


  const onRejectOrder = async (orderId, status, courierName, data) => {
    if(window.confirm(`Kamu yakin mau ${status} order?`)) {
      updateAdminOrderStatus(token, orderId, status, data)
        .then(res => {
          if(res.success){
            alert(`Sudah Diganti ke status ${res.status}`);
            props.onRefresh();
          } else {
            alert(res.error)
          }
        })
    }
  };


  const onUpdateOrder = async (orderId, status, courierName, data) => {
    if(window.confirm(`Kamu yakin mau ${status} order?`)) {
      updateAdminOrderStatus(token, orderId, status, data)
        .then(res => {
          if(res.success){
            alert(`Sudah Diganti ke status ${res.status}`);
            props.onRefresh();
          } else {
            alert(res.error)
          }
        })
    }
  };

  const onDeleteOrder = async (orderId) => {
      if(window.confirm(`Kamu yakin mau cancel order?`)) {
          deleteAdminOrder(token, orderId)
              .then(res => {
                  if(res.success){
                      alert(`Berhasil delete order`);
                      props.onRefresh();
                  } else {
                      alert(res.error)
                  }
              })
      }
  };

  const onConfirmBatchOrder = async () => {
        let message,status;
        if (props.tab === 0) {
            alert("Tidak bisa update orderan yang belum bayar");
            return
        }

        switch (props.tab) {
            case 1:
                status = 'confirmed';
                break;
            case 2:
                status = 'allocated';
                break;
            case 3:
                status = 'pickingUp';
                break;
            case 4:
                status = 'picked';
                break;
            case 5:
                status = 'droppingOff';
                break;
            case 6:
            case 7:
                status = 'delivered';
                break;
            default:
                break;
        }

        if(window.confirm('Kami akan segera mempesan order kamu. Kamu yakin?')) {
            setLoadings({...loadings, view:true, message:'Mengupdate Order...'});
            confirmAdminBatchOrder(token, selectedData,status)
                .then(res => {
                    if (res.failedOrders > 0 && res.successOrders > 0) {
                        message = `${res.successOrders} Pesanan Berhasil diupdate. ${res.failedOrders} Pesanan gagal diupdate. `
                    } else if (res.failedOrders > 0 && res.successOrders === 0) {
                        message = `${res.failedOrders} Pesanan gagal diupdate.`
                    } else if (res.failedOrders === 0 && res.successOrders > 0) {
                        message = `${res.successOrders} Pesanan Berhasil diupdate.`
                    }
                    alert(message);
                    window.location.reload()
                });
        }
  };

  const onConfirmBatchPlacedOrders = () => {
      let message;
      if(window.confirm('Kami akan segera mempesan order kamu. Kamu yakin?')) {
          setLoadings({...loadings, view:true, message:'Mengconfirm Order...'});
          confirmAdminBatchPlacedOrders(token, selectedData,'confirmed')
              .then(res => {
                  if (res.failedOrders > 0 && res.successOrders > 0) {
                      message = `${res.successOrders} Pesanan Berhasil dikonfirmasi. ${res.failedOrders} Pesanan gagal dikonfirmasi. `
                  } else if (res.failedOrders > 0 && res.successOrders === 0) {
                      message = `${res.failedOrders} Pesanan gagal dikonfirmasi.`
                  } else if (res.failedOrders === 0 && res.successOrders > 0) {
                      message = `${res.successOrders} Pesanan Berhasil dikonfirmasi.`
                  }
                  alert(message);
                  window.location.reload()
              });
      }
  }

  const onDeleteBatchOrders = () => {
    let message;
    if(window.confirm('Kami akan segera menghapus order kamu. Kamu yakin?')) {
      if(window.confirm('Mohon konfirmasi kembali. Apakah Anda yakin?')) {
        setLoadings({...loadings, view:true, message:'Menghapus Order...'});
        deleteAdminBatchOrders(token, selectedData)
            .then(res => {
                if (res.failedOrders > 0 && res.successOrders > 0) {
                    message = `${res.successOrders} Pesanan Berhasil dihapus. ${res.failedOrders} Pesanan gagal dihapus. `
                } else if (res.failedOrders > 0 && res.successOrders === 0) {
                    message = `${res.failedOrders} Pesanan gagal dihapus.`
                } else if (res.failedOrders === 0 && res.successOrders > 0) {
                    message = `${res.successOrders} Pesanan Berhasil dihapus.`
                }
                alert(message);
                window.location.reload()
            });
      }
    }
  }

  const onStatusChange = async (orderId, status, courierWaybillId, data, isForced) => {
    if(status === 'allocated' && (!courierWaybillId)) {
      alert("Kamu belum memasukan nomor resi kurir");
      return
    }
    if(window.confirm('Kamu yakin mau update status?')) {
      let newStatus = await nextStatus(status,isForced);
      updateAdminOrderStatus(token, orderId, newStatus, data, isForced)
        .then(res => {
          if(res.success){
            alert(`Sudah Diganti ke status ${res.status}`);
            props.onRefresh();
          } else {
            alert(res.error)
          }
        })
    }
  };
  
  const handleChange = name => e => {
    const value = e.target.value;
    setValues({ ...values, error:false, success:false, [name]: value });
  };

  const modal = () => {
    let form;
    let onClick;
    let title;
    if (modalType === 'info') {
      title = 'Masukkan Info';
      onClick = () => onSubmitCourierDetails();
      form = (
        <CourierDetailsForm
          handleChange={handleChange}
          values={values}
        />
      );
    } else if (modalType === 'deliveryNote'){
      title = 'Masukkan Detail Kurir';
      onClick = () => onSubmitDeliveryNote();
      form = (
        <DeliveryNoteForm
          handleChange={handleChange}
          values={values}
        />
      );
    } else if (modalType === 'priceChange') {
      title = 'Masukkan Harga Baru';
      onClick = () => onSubmitPriceChange();
      form = (
          <div className="form-group">
            <input
                type="number"
                onChange={handleChange('price')}
                placeholder="Harga Baru"
                className="form-control"
                value={values.price}
            />
          </div>
      )
    } else if (modalType === 'items') {
        title = 'Detail Barang';
        form = (
          <div>
            <h5>{ values.courierCompany } <span className="badge badge-info">{values.courierType}</span></h5>
            <h6>Barang </h6>
            { values.items.map((i,idx) => (
                <div className="bg-lighter border rounded p-2 mb-1">
                  <small><b>Barang {idx+1}</b></small><br/>
                  <h6 className="mb-0">{ i.name ? i.name : ''}</h6>
                  <b>{i.quantity}x - {i.description}</b> - Rp. {numeral(i.value).format("0,0")} <br/>
                  <small><b>Dimensi & Berat</b></small> <br/>
                  P{i.length}cm x L{i.width}cm x T{i.height}cm - Berat {i.weight} gram
                </div>
            ))}
          </div>
        )
    } else if (modalType === 'print') {
        title = 'Print Label';
        form = (
            <div>
                <PDFDownloadLink className="btn-block btn btn-light" document={<WaybillOrder order={data}/>} fileName={`label-${data.orderId}.pdf`}>
                    {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download Label')}
                </PDFDownloadLink>
            </div>
        )
    } else if (modalType === 'printSelected') {
        title = 'Print Label Banyak';
        form = (
            <div>
                <PDFDownloadLink className="btn-block btn btn-light" document={<WaybillBulkOrder order={selectedData}/>} fileName={`label-${Date.now()}.pdf`}>
                    {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download All Label')}
                </PDFDownloadLink>
            </div>
        )
    }

    return (
      <Modal show={show} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <h5>
            { title }
          </h5>
        </Modal.Header>
        <Modal.Body>
          { form }
        </Modal.Body>
        {
          modalType === 'items' || modalType === 'print' || modalType === 'printSelected'? '' :
              <Modal.Footer>
                <Button variant="secondary btn-sm" onClick={handleModalClose}>
                  Tutup
                </Button>
                <Button variant="primary btn-sm" onClick={onClick}>
                  Simpan
                </Button>
              </Modal.Footer>
        }
      </Modal>
    );
  };

  const courierCell = (original) => {
    const {
      orderId,
      courierTrackingId,
      courierName,
      courierType,
      courierCompany,
      courierPhone,
      courierWaybillId,
      courierLink,
      isInstantWaybill,
      status
    } = original;

    let company = normalizeCourierServices(courierCompany, courierType).companyName;
    let type = normalizeCourierServices(courierCompany, courierType).typeView;
    let companyType;
    let instantWaybillView =  isInstantWaybill ?
        <span className="badge badge-danger">
            Resi Instant
        </span> : null;


    if (original.orderType === "pickupAppBulk") {
      let arr = courierCompany.split(",");
      if (arr.length > 1 ) {
          let normalizeArr = arr.reduce((r,i) => {
              r.push(normalizeCourierServices(i).companyName);
              return r
          },[])
          companyType = normalizeArr.toString()
      } else {
          companyType = normalizeCourierServices(courierCompany).companyName
      }

    } else {
      companyType = company + " - " + type;
    }

    if (status === 'cancelled' || status === 'rejected' ||
      status === 'courierNotFound') {
      return (
        <div>
          {companyType}
        </div>
      )
    } else if ( status === 'delivered' ) {
      return (
        <div>
          { companyType + " - " + courierName + " - " + courierPhone}
        </div>
      )
    } else if (!courierName) {
        if (original.orderType === "pickupAppBulk") {
            return (
                <div>
                    Multi Kurir <br/>
                    {companyType} <br/>
                    { instantWaybillView }
                </div>
            )
        } else {
            return (
                <div>
                    No: {courierWaybillId} <br/>
                    {companyType} <br/>
                    <button
                        onClick={() => handleModalShow(orderId,courierTrackingId,courierWaybillId, courierCompany,courierType,"info")}
                        className="badge badge-primary customer-cell-btn-primary pointer"
                    >
                        Masukkan Kurir
                    </button>
                    { instantWaybillView }
                </div>
            )
        }
    } else {
      return (
        <div>
          No: {courierWaybillId} <br/>
          {companyType + " - " + courierName + " - " + courierPhone}
          <br/>
          Link: {courierLink}
          <br/>
          <button
            onClick={() => handleModalShow(orderId,courierTrackingId,courierWaybillId, courierCompany,courierType,"info")}
            className="badge badge-primary customer-cell-btn-primary pointer"
            >
            Edit Kurir
          </button>
            { instantWaybillView }
        </div>
      )
    }
  };

  const filterCaseInsensitive = (filter, row)  => {
    const id = filter.pivotId || filter.id;
    return (
        row[id] !== undefined ?
            String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
            :
            true
    );
  };

  if (loadings.view) {
      return (
          <div className="text-center row">
              <div className="col-3"/>
              <div className="row col-5 py-5">
                  <ReactLoading
                      type={'bubbles'}
                      color={'#459BD8'}
                      height={54}
                      width={75}
                  />
                  <h5 className="mt-4 "><strong> {loadings.message}</strong></h5>
              </div>
              <div className="col-4"/>
          </div>
      );
  }

  return (
    <div>
      { modal() }
      <EditOrderForm
          type={"admin"}
          orderId={selectedOrderId}
          show={editOrderModal}
          onHide={() => setEditOrderModal(false)}
      />
      <ReactTable
        data={props.data}
        columns={columns}
        defaultPageSize={50}
        filterable
        loading={props.loading}
        defaultFilterMethod={filterCaseInsensitive}
        className="-striped -highlight"
      />
    </div>
  )
};

export default AdminOrderTable;
